{
  "calendar.addTeammates.alreadyIn": "{name} is already in Team",
  "calendar.addTeammates.cancel": "Cancel",
  "calendar.addTeammates.close": "Close add teammates",
  "calendar.addTeammates.enterQuery": "Enter a nickname or email",
  "calendar.addTeammates.heading": "Add teammates",
  "calendar.addTeammates.label": "Teammate",
  "calendar.addTeammates.noMatch": "No matching teammate found",
  "calendar.addTeammates.pickMatch": "Select a teammate from the matches",
  "calendar.addTeammates.placeholder": "Nickname or email",
  "calendar.addTeammates.submit": "Add teammate",
  "calendar.addTeammates.subtitle": "Search the workspace directory by nickname or email",
  "calendar.addTeammates.thisTeammate": "This teammate",
  "calendar.addTeammates.unnamed": "Unnamed teammate",
  "calendar.agenda.allDay": "All day",
  "calendar.agenda.empty": "No events in these days.",
  "calendar.agenda.title": "Agenda",
  "calendar.agenda.untitled": "Untitled event",
  "calendar.agenda.who.me": "my events",
  "calendar.agenda.who.team": "the team",
  "calendar.aiForm.field.date": "Date",
  "calendar.aiForm.field.description": "Description",
  "calendar.aiForm.field.end": "Ends",
  "calendar.aiForm.field.invitees": "Invitees",
  "calendar.aiForm.field.start": "Starts",
  "calendar.aiForm.field.title": "Title",
  "calendar.aiForm.title": "Event",
  "calendar.booking.close": "Close",
  "calendar.booking.defaultTitle": "New event",
  "calendar.booking.deleteEvent": "Delete event",
  "calendar.booking.descriptionPlaceholder": "Optional notes",
  "calendar.booking.endRepeat": "End repeat",
  "calendar.booking.fieldStartDate": "Start Date",
  "calendar.booking.fieldEndDate": "End Date",
  "calendar.booking.fieldDescription": "Description",
  "calendar.booking.fieldEnd": "End",
  "calendar.booking.fieldInvitees": "Invitees",
  "calendar.booking.fieldMeetingUrl": "Meeting URL",
  "calendar.booking.fieldReminder": "Reminder",
  "calendar.booking.fieldRepeat": "Repeat",
  "calendar.booking.fieldStart": "Start",
  "calendar.booking.fieldTitle": "Title",
  "calendar.booking.headingEdit": "Edit Booking",
  "calendar.booking.headingNew": "New Booking",
  "calendar.booking.inviteesPlaceholder": "Type a name…",
  "calendar.booking.moveBody": "Update the time directly, or propose the change and wait for participants to confirm.",
  "calendar.booking.moveCancel": "Cancel",
  "calendar.booking.moveHeading": "This event has participants",
  "calendar.booking.moveOrganizerOnly": "Only the organizer can move this event.",
  "calendar.booking.movePropose": "Propose",
  "calendar.booking.moveUpdate": "Update",
  "calendar.booking.save": "Save",
  "calendar.booking.scopeAll": "All events in series",
  "calendar.booking.scopeCancel": "Cancel",
  "calendar.booking.scopeFuture": "This and future events",
  "calendar.booking.scopeHeading": "Edit recurring event",
  "calendar.booking.scopeSubtitle": "Apply changes to:",
  "calendar.booking.scopeThis": "This event only",
  "calendar.booking.subtitleEdit": "Update the meeting time, attendees, or description",
  "calendar.booking.subtitleNew": "Schedule a meeting and invite teammates",
  "calendar.booking.titlePlaceholder": "Add a title",
  "calendar.booking.unavailable": "Unavailable",
  "calendar.booking.update": "Update",
  "calendar.booking.urlPlaceholder": "Paste Zoom, Google Meet, or other link",
  "calendar.day.fri": "Fri",
  "calendar.day.mon": "Mon",
  "calendar.day.sat": "Sat",
  "calendar.day.sun": "Sun",
  "calendar.day.thu": "Thu",
  "calendar.day.tue": "Tue",
  "calendar.day.wed": "Wed",
  "calendar.dayInitial.fri": "F",
  "calendar.dayInitial.mon": "M",
  "calendar.dayInitial.sat": "S",
  "calendar.dayInitial.sun": "S",
  "calendar.dayInitial.thu": "T",
  "calendar.dayInitial.tue": "T",
  "calendar.dayInitial.wed": "W",
  "calendar.delete.allFuture": "Delete all future events",
  "calendar.delete.bodyRecurring": "Choose which occurrences to delete. Deleted occurrences cannot be restored.",
  "calendar.delete.bodySeries": "This permanently removes the event and all its occurrences",
  "calendar.delete.bodySingle": "This permanently removes the event from the calendar",
  "calendar.delete.confirm": "Delete",
  "calendar.delete.confirmTitle": "Delete “{title}”?",
  "calendar.delete.eventFallback": "event",
  "calendar.delete.failedMessage": "The event could not be deleted — reopen it and try again.",
  "calendar.delete.failedTitle": "Event not deleted",
  "calendar.delete.onlyThis": "Delete only this event",
  "calendar.delete.recurringTitle": "Delete the recurring event “{title}”?",
  "calendar.detail.accept": "Accept",
  "calendar.detail.askAi": "Ask AI",
  "calendar.detail.callFailedMessage": "Meet room creation failed. Check your connection or try again.",
  "calendar.detail.callFailedTitle": "Could not start call",
  "calendar.detail.callName": "Calendar call",
  "calendar.detail.createdBy": "Created by {name}",
  "calendar.detail.decline": "Decline",
  "calendar.detail.delete": "Delete event",
  "calendar.detail.edit": "Edit event",
  "calendar.detail.eventFallback": "Event",
  "calendar.detail.going": "Going?",
  "calendar.detail.joinCall": "Join call",
  "calendar.detail.notFoundMessage": "The event was deleted, or you do not have access to it.",
  "calendar.detail.notFoundTitle": "Event not found",
  "calendar.detail.privateTitle": "Meeting",
  "calendar.detail.proposedBy": "Proposed by {name} — awaiting confirmation",
  "calendar.detail.proposedByFallback": "a participant",
  "calendar.detail.rsvpMaybe": "Maybe",
  "calendar.detail.rsvpNo": "No",
  "calendar.detail.rsvpYes": "Yes",
  "calendar.detail.restoreFailedMessage": "The event details could not be restored. Close the dialog and open the event again.",
  "calendar.detail.restoreFailedTitle": "Event details unavailable",
  "calendar.event.untitled": "Untitled event",
  "calendar.header.addTeammates": "Add teammates",
  "calendar.header.calendar": "Calendar",
  "calendar.header.newBooking": "New booking",
  "calendar.header.nextDay": "Next day",
  "calendar.header.nextMonth": "Next month",
  "calendar.header.nextWeek": "Next week",
  "calendar.header.prevDay": "Previous day",
  "calendar.header.prevMonth": "Previous month",
  "calendar.header.prevWeek": "Previous week",
  "calendar.header.railAria": "Open the calendar rail",
  "calendar.header.railTooltip": "Mini month and people",
  "calendar.header.resync": "Resync from Google",
  "calendar.header.today": "Today",
  "calendar.mini.nextMonth": "Next month",
  "calendar.mini.prevMonth": "Previous month",
  "calendar.mode.externalUrl": "External URL",
  "calendar.mode.offline": "Offline",
  "calendar.mode.symbolsMeet": "Symbols Meet",
  "calendar.month.april": "April",
  "calendar.month.august": "August",
  "calendar.month.december": "December",
  "calendar.month.february": "February",
  "calendar.month.january": "January",
  "calendar.month.july": "July",
  "calendar.month.june": "June",
  "calendar.month.march": "March",
  "calendar.month.may": "May",
  "calendar.month.november": "November",
  "calendar.month.october": "October",
  "calendar.month.september": "September",
  "calendar.monthView.days": "Days",
  "calendar.monthView.events": "Events",
  "calendar.page.calendar.title": "Calendar",
  "calendar.profile.availabilityHeading": "General availability",
  "calendar.profile.displayNameLabel": "Display name",
  "calendar.profile.displayNamePlaceholder": "Your name",
  "calendar.profile.fieldGithub": "GitHub",
  "calendar.profile.fieldLocalTime": "Local time",
  "calendar.profile.fieldLocation": "Location",
  "calendar.profile.fieldPosition": "Position",
  "calendar.profile.fieldRole": "Role",
  "calendar.profile.fieldTeam": "Team",
  "calendar.profile.fieldTenure": "Tenure",
  "calendar.profile.githubLabel": "GitHub username",
  "calendar.profile.githubPlaceholder": "e.g. nikoloza",
  "calendar.profile.heading": "Profile",
  "calendar.profile.hintReadOnly": "Read only",
  "calendar.profile.hintToggle": "Click to toggle",
  "calendar.profile.hintToggleAdmin": "Click to toggle (admin)",
  "calendar.profile.locationLabel": "Location",
  "calendar.profile.locationPlaceholder": "City, Country",
  "calendar.profile.message": "Message",
  "calendar.profile.noAvailability": "No availability set",
  "calendar.profile.noTitle": "(no title)",
  "calendar.profile.openProfile": "Open profile",
  "calendar.profile.positionLabel": "Position / Title",
  "calendar.profile.positionPlaceholder": "e.g. Frontend Engineer",
  "calendar.profile.summary.availableNow": "Available now",
  "calendar.profile.summary.nextAvailable": "Next available {day} {time}",
  "calendar.profile.summary.noHours": "No available hours set",
  "calendar.profile.summary.until": "until {time}",
  "calendar.profile.summary.weeklyHours": "{hours} hr/w",
  "calendar.profile.tabAvailability": "Availability",
  "calendar.profile.tabProfile": "Profile",
  "calendar.profile.tabSettings": "Settings",
  "calendar.profile.teamLabel": "Team",
  "calendar.profile.tenureNew": "New",
  "calendar.profile.timezoneLabel": "Timezone (IANA)",
  "calendar.profile.timezonePlaceholder": "Select timezone…",
  "calendar.profile.weeklyHoursLabel": "Weekly hours (auto from grid)",
  "calendar.proposal.acceptMessage": "“{title}” moves to the new time for everyone invited. Connected calendars update too.",
  "calendar.proposal.acceptTitle": "Accept the proposed time?",
  "calendar.proposal.declineMessage": "The proposal is deleted. “{title}” keeps its current time.",
  "calendar.proposal.declineTitle": "Decline the proposed time?",
  "calendar.quick.fieldTitle": "Title",
  "calendar.quick.moreOptions": "More options",
  "calendar.quick.save": "Save",
  "calendar.quick.titlePlaceholder": "Add a title",
  "calendar.reminder.day1": "1 day before",
  "calendar.reminder.hour1": "1 hour before",
  "calendar.reminder.hour12": "12 hours before",
  "calendar.reminder.hour4": "4 hours before",
  "calendar.reminder.hour8": "8 hours before",
  "calendar.reminder.min10": "10 minutes before",
  "calendar.reminder.min15": "15 minutes before",
  "calendar.reminder.min30": "30 minutes before",
  "calendar.reminder.min5": "5 minutes before",
  "calendar.reminder.none": "No reminder",
  "calendar.rsvp.scopeCancel": "Cancel",
  "calendar.rsvp.scopeFuture": "All future occurrences",
  "calendar.rsvp.scopeHeading": "Apply RSVP response",
  "calendar.rsvp.scopeSubtitle": "Choose which occurrences this response applies to.",
  "calendar.rsvp.scopeThis": "This occurrence",
  "calendar.repeat.biweekly": "Every 2 weeks",
  "calendar.repeat.daily": "Daily",
  "calendar.repeat.endAfter": "After",
  "calendar.repeat.endOn": "On date",
  "calendar.repeat.monthly": "Monthly",
  "calendar.repeat.never": "Never",
  "calendar.repeat.occurrenceMany": "occurrences",
  "calendar.repeat.occurrenceOne": "occurrence",
  "calendar.repeat.weekly": "Weekly",
  "calendar.repeat.yearly": "Yearly",
  "calendar.save.failedMessage": "The change could not be saved — reopen the event and try again.",
  "calendar.save.failedTitle": "Event not saved",
  "calendar.save.invalidRangeMessage": "Choose an end date and time after the event starts.",
  "calendar.save.invalidRangeTitle": "End must be after start",
  "calendar.save.pastMessage": "Choose a time from now onward and try again.",
  "calendar.save.pastTitle": "Booking starts in the past",
  "calendar.sidebar.advisors": "ADVISORS",
  "calendar.sidebar.investors": "INVESTORS",
  "calendar.sidebar.navLabel": "Calendar",
  "calendar.sidebar.railLabel": "Calendar",
  "calendar.sidebar.team": "TEAM",
  "calendar.team.hideColumn": "Hide column",
  "calendar.type.busy": "Unavailable",
  "calendar.type.general": "Company event",
  "calendar.type.meeting": "Meeting",
  "calendar.view.day": "Day",
  "calendar.view.month": "Month",
  "calendar.view.team": "Team",
  "calendar.view.teamNow": "Team Now",
  "calendar.view.week": "Week",
  "calendar.week.backToMine": "Back to my week",
  "calendar.week.viewingOther": "Viewing {name}'s week"
}
